import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

const galleryImg = document.querySelectorAll('.galleryImg');

document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.mySwiper', {
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    spaceBetween: 12,
    initialSlide: 0,
    dots: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-nav',
      type: 'bullets',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: false,
      },
      1440: {
        slidesPerView: 3,
        spaceBetween: 36,
        centeredSlides: false,
      },
    },
  });
});
